module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-flex"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Date Received\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "paymentDate",
      "table-control": true,
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:paymentDate.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "paymentDate",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValid()
      }
    },
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.paymentDateInvalid
    }
  }, [_vm._v("\n                    Payment date must be on or after the date of injury (" + _vm._s(_vm.periodStart) + ") and a valid date.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                Payment\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "payment_total",
      "table-control": true,
      "icon-space": false,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.payment.total),
      expression: "payment.total",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "payment-received",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.payment.total)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "total", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateValid()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.paymentTotalInvalid
    }
  }, [_vm._v("\n                    Payment must be greater than £0.\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third u-margin-top-40"
  }, [_c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.removePayment()
      }
    }
  }, [_vm._v("Delete Payment")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-585241a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/past-loss-of-earnings/PostAccidentPayments.vue
// module id = 1703
// module chunks = 0